import { IAction } from "store";
import { itemObjectHandlers } from "utils/item-object-handlers";
import { DealAction } from "../../actions";
import { INote, INoteMeta, INoteLock, IHandleItem } from "../../types";
import { reducer } from "../index";

reducer.createHandler(DealAction.GetNoteMetaSuccess, (state, { payload }: IAction<INoteMeta>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    noteMeta: payload
  }
}));

reducer.createHandler(DealAction.InvalidateNoteMeta, (state) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    noteMeta: {}
  }
}));

reducer.createHandler(DealAction.SetNoteLockSocket, (state, { payload }: IAction<INoteLock>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    noteLock: payload
  }
}));

reducer.createHandler(DealAction.GetNotesSuccess, (state, { payload }: IAction<Record<number, INote>>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    notes: payload
  }
}));

reducer.createHandler(DealAction.HandleNoteSuccess, (state, { payload }: IAction<IHandleItem<INote>>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    notes: itemObjectHandlers[payload.event](payload.item, state.dealModule.notes)
  }
}));
